"use strict";
// Keep in line with single_product.ts
// TODO: check all the keeps in line and see if you can clean that up
var productGrids = document.querySelectorAll('.product-grid-splide');
productGrids.forEach(function (productGrid) {
    // @ts-ignore
    var productGridSplide = new Splide(productGrid, {
        perPage: 4,
        perMove: 1,
        type: 'loop',
        gap: "30px",
        padding: {
            left: "0%",
            right: "100px"
        },
        pagination: true,
        arrows: true,
        breakpoints: {
            1199: {
                perPage: 3,
                gap: "15px",
                padding: {
                    left: "0%",
                    right: "50px"
                },
            },
            991: {
                perPage: 2,
                gap: "15px",
                padding: {
                    left: "0%",
                    right: "50px"
                },
            },
            480: {
                perPage: 1,
                gap: "15px",
                padding: {
                    left: "0%",
                    right: "50px"
                },
            },
        },
    }).mount();
    productGridSplide.on("moved", function (newIndex) {
        var _a;
        (_a = productGrid.querySelector(".splide__arrows .splide__pagination.scroll-dots li button.is-active")) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest"
        });
    });
});
